import React from "react";
// import { Logo } from "@veriff/genoma";
import "./header.css";

const Header = () => {
    return (
        <div className="Header">
            <img className="header-logo" alt="veriff-logo" src="/logo.png" />
            <h2 className="header-title">Data upload</h2>
        </div>
    );
};

export default Header;
